export default "__VITE_ASSET__CpcU8vw$__"